import { EITAA_BASE_URL, SUPPORT_EITAA_USERNAME } from "@/utils/constant";

export type SupportFaqItem = {
  /** Stable key for the list and the accordion item. */
  id: string;
  question: string;
  /**
   * Inline answer, rendered with `whitespace-pre-line` so blank lines shape
   * the text. Set this or `url`, never both.
   */
  answer?: string;
  /** When set, the question opens this link instead of expanding in place. */
  url?: string;
};

/** The FAQ list, in display order. */
export const SUPPORT_FAQ: SupportFaqItem[] = [
  {
    id: "what-is-amoozim",
    question: "آموزیم چیست؟",
    answer: `«آموزیم» یک پلتفرم جامع آموزش آنلاین در ایتاست که دوره‌های متنوعی در دسته‌بندی‌هایی مثل برنامه‌نویسی، دیجیتال و رسانه، کودک و خانواده، زبان‌های خارجی، روانشناسی و مهارت‌های زندگی ارائه می‌دهد. این پلتفرم بستری برای مدرسان و یادگیرندگان فراهم کرده تا محتوای آموزشی رو به‌صورت ویدیویی، صوتی یا تعاملی منتشر و مصرف کنند.`,
  },
  {
    id: "build-miniapp",
    question: "چگونه مینی‌اپ یا برنامک آموزشی بسازیم؟",
    url: `${EITAA_BASE_URL}/Amoozim_creator/31`,
  },
  {
    id: "publish-course",
    question: "چطوری دوره‌مون رو در ویترین انتشار بدیم؟",
    answer: `برای اینکه دوره‌تون رو در ویترین آموزیم منتشر کنید، کافیه مراحل زیر رو به‌ترتیب انجام بدید:

۱. انتخاب دوره
ابتدا وارد بخش (+) بشید و دوره‌ای که می‌خواید در ویترین منتشر کنید رو انتخاب کنید.

۲. انتخاب «انتشار در ویترین»
از کادر بالای صفحه، گزینه «انتشار در ویترین» رو انتخاب کنید.

۳. بررسی شرایط و قرارداد
در این بخش، شرایط انتشار دوره در ویترین رو مطالعه کنید. سپس قرارداد همکاری آموزیم رو بررسی و مطالعه کنید. برای امضای قرارداد، کد تأییدی که در همین بخش براتون ارسال می‌شه رو وارد کنید تا قرارداد به‌صورت الکترونیکی امضا بشه.

۴. تکمیل اطلاعات دوره
در ادامه، اطلاعات موردنیاز برای نمایش دوره به خریداران رو وارد کنید.

۵. ارسال درخواست
بعد از تکمیل اطلاعات، روی گزینه «درخواست انتشار در ویترین» کلیک کنید.

به همین راحتی، درخواست انتشار دوره‌تون در ویترین آموزیم ثبت می‌شه.`,
  },
  {
    id: "why-trust-amoozim",
    question: "چرا باید به آموزیم اعتماد کنم؟",
    answer: `آموزیم مرجع رسمی انتشار دوره‌های آموزشی در ایتاست. در آموزیم می‌تونید با خیال راحت به دانش خودتون اضافه کنید. و با امکاناتی که آموزیم در اختیارتون می‌ذاره، می‌تونید تجربه‌ای راحت‌تر و مطمئن‌تر از آموزش داشته باشید:

🎓 دسترسی به دوره‌های آموزشی آکادمی‌ها و اساتید برتر.
💳 خرید اقساطی همه دوره‌ها در ۴ قسط.
📚 مشاهده سرفصل‌های دوره قبل از خرید.
💬 برخورداری از پشتیبانی اختصاصی دوره و پشتیبانی آموزیم.
🏅 دریافت گواهی پایان دوره.
✅ تضمین کیفیت دوره و امکان بازگشت وجه در صورت وجود مشکل جدی در کیفیت یا محتوای دوره.`,
  },
  {
    id: "installment-purchase",
    question: "چطور می‌تونم دوره موردنظرم رو در آموزیم به‌صورت اقساطی خریداری کنم؟",
    answer: `دوره‌ای که همیشه دوست داشتی یاد بگیری، حالا راحت‌تر از همیشه در دسترسته!

با امکان خرید ۴ قسطه بدون کارمزد در آموزیم، فقط با پرداخت ۲۵٪ مبلغ دوره می‌تونی یادگیری رو شروع کنی و باقی مبلغ رو در سه قسط بعدی پرداخت کنی.

برای خرید دوره آموزشی به صورت اقساطی:

۱. وارد ویترین آموزیم بشید و دوره موردنظرتون رو انتخاب کنید.

۲. روی گزینه «خرید دوره» کلیک کنید تا وارد صفحه تکمیل خرید بشید.

۳. در بخش شیوه پرداخت، گزینه «پرداخت قسطی و اعتباری با اسنپ‌پی» رو انتخاب کنید.

۴. اگر کد تخفیف دارید، اون رو وارد کنید و روی «ثبت» بزنید.

حالا می‌تونید با خیال راحت دوره رو شروع کنید و هزینه‌ش رو در ۴ قسط پرداخت کنید.`,
  },
  {
    id: "discount-code",
    question: "چطور می‌تونم از کد تخفیفم برای خرید دوره استفاده کنم؟",
    answer: `برای استفاده از کد تخفیف، کافیه مراحل زیر رو انجام بدید:

۱. وارد ویترین آموزیم بشید و دوره‌ای که می‌خواید خریداری کنید رو انتخاب کنید.
۲. روی گزینه «خرید دوره» بزنید.
۳. در مرحله بعد، گزینه «کد تخفیف» رو فعال کنید.
۴. کد تخفیف خودتون رو وارد کنید و روی «ثبت» بزنید.
۵. در نهایت، گزینه «پرداخت و خرید دوره» رو انتخاب کنید.

به همین راحتی کد تخفیف روی خریدتون اعمال میشه و می‌تونید دوره رو تهیه کنید 😊`,
  },
  {
    id: "settlement",
    question: "درآمد حاصل از فروش دوره‌ها چه زمانی و چطور به حسابم واریز میشه؟",
    answer: `در آموزیم، فرآیند تسویه حساب به شکلی طراحی شده که بتونید با خیال راحت روی تولید محتوای آموزشی تمرکز کنید.

🔹 نحوه واریز:
مبلغ تسویه مستقیماً به شماره شبایی که در پروفایل کاربریتون ثبت کردید واریز میشه. فقط توجه داشته باشید که نام صاحب حساب باید با نامی که در پنل احراز هویت شده، یکسان باشه.

🔹 کارمزد و مبلغ دریافتی:
هیچ هزینه پنهانی در زمان تسویه وجود نداره. سهم آموزیم و هزینه‌های انتقال بانکی (در صورت وجود) به‌صورت شفاف در پنل نمایش داده میشه و باقی مبلغ به حساب شما واریز خواهد شد.

🔹 پیگیری وضعیت تسویه:
برای مشاهده تاریخچه واریزی‌ها، وضعیت درخواست‌های تسویه و جزئیات تراکنش‌ها، می‌تونید از طریق پنل کاربریتون اقدام کنید.

در نتیجه، همه جزئیات مالی و وضعیت تسویه‌ها همیشه براتون قابل مشاهده و پیگیریه 🌱`,
  },
  {
    id: "course-access-duration",
    question: "دوره خریداری‌شده تا چه زمانی برای من قابل دسترسی است؟",
    answer: `در صورت عدم تمدید اشتراک از سوی مالک برنامک، دوره همچنان در برنامک اختصاصی ایشان باقی می‌ماند؛ اما از ویترین آموزیم حذف می‌شود و دیگر در بخش ویترین نمایش داده نخواهد شد.`,
  },
  {
    id: "multi-device-access",
    question: "آیا بعد از خرید دوره، امکان مشاهده آن در چند دستگاه وجود دارد؟",
    answer: `بله، اما تعداد دستگاه‌ها توسط مالک یا ادمین برنامک تعیین می‌شود. بسته به تنظیمات هر دوره، دسترسی می‌تواند روی یک دستگاه یا تعداد مشخصی دستگاه محدود شود.`,
  },
  {
    id: "download-videos",
    question: "آیا امکان دانلود ویدیوهای دوره وجود دارد؟",
    answer: `امکان دانلود برای هنرجوها وجود ندارد.

همچنین در صورت فعال بودن حفاظت از محتوا، امکان گرفتن اسکرین‌شات و اسکرین‌رکورد برای کاربران دوره محدود می‌شود.`,
  },
  {
    id: "refund",
    question: "آیا امکان بازگشت وجه دوره خریداری‌شده وجود دارد؟",
    answer: `آموزیم با این اطمینان که کیفیت این دوره تضمین شده است، تلاش می‌کند دوره‌هایی با کیفیت و مطابق با توضیحات ارائه‌شده در اختیار شما قرار دهد. با این حال، اگر پس از مشاهده بخشی از دوره، مشکل جدی در کیفیت یا محتوای آن مشاهده کردید، می‌توانید برای بررسی بازگشت وجه به پشتیبانی آموزیم از طریق آدرس @${SUPPORT_EITAA_USERNAME} پیام بدهید.

درخواست شما بررسی می‌شود و در صورت تأیید مشکل، مبلغ پرداختی به شما بازگردانده خواهد شد.`,
  },
  {
    id: "course-support-contact",
    question:
      "برای دریافت پشتیبانی درباره یک دوره، از چه طریقی با پشتیبان دوره ارتباط بگیرم؟",
    answer: `برای دریافت پشتیبانی، می‌توانید از طریق آدرس @${SUPPORT_EITAA_USERNAME} با تیم پشتیبانی آموزیم در ارتباط باشید. این آدرس برای پیگیری و دریافت راهنمایی درباره دوره‌ها و سایر موارد پشتیبانی در دسترس است.`,
  },
];
